import React from 'react'
import Blog1_BgImage from './Blog1_BgImage'
import Blog1_cat from './Blog1_cat'
import HeaderLine from '../../Header_RedLine/Dec6_HeaderRL';
import ResponsiveNavbar from '../../ResponsiveNavbar/Dec6_Navbar';
import AboveFooter from '../../AboveFooter/Dec6_AboveFooter';
import Footer from '../../Footer/Dec6_Footer';
import Scroll_To_Top from '../../Scroll_To_Top/Dec6_STTop';
import {Helmet} from "react-helmet";
 

export default  function Blog1(){
     return(
<>
<Helmet>
            <title>Insights | Dec6 Consulting Pvt Ltd</title>
            <meta name="description" content="Dec6 Consulting Private Limited" />
            <link rel="canonical" href="https://www.dec6.ca/Insights" />
        </Helmet>
        <Scroll_To_Top/>
        <HeaderLine/>
        <ResponsiveNavbar/>
<Blog1_BgImage/>
<Blog1_cat/>
<AboveFooter/>
        <Footer/>
</>
     )
 }